/* MENU */


var menuShowItems = anime({
    targets: document.querySelectorAll('#menu ul.nav>li'),
    opacity: '1',
    autoplay: false,
    duration: 1200,
    easing: 'easeOutQuad',
    translateY: '-20px',
    complete: function(anim) {
        /*console.log('finito');*/
        
    },
    begin: function(anim) {
        /*console.log('inizio');*/

        
    },
    delay: function(el, i, l) {
        
        if(i===0){
            return 300;

        }else{
             return (300+(i * 250 +(50*i)));

        }
       
    }
});

/* ANIMAZIONE MENU SECONDARIO HOME */

var menuHome = anime({
    targets: document.querySelectorAll('#menu-home li'),
    opacity: '1',
    autoplay: false,
    duration: 600,
    easing: 'easeOutQuad',
    translateY: '-10px',
    complete: function(anim) {
        /*console.log('finito');*/
    },
    begin: function(anim) {
        /*console.log('inizio');*/
        
        
    },
    delay: function(el, i, l) {
        
        return (i * 150);
    }
});


/* ANIMAZIONE DEL MENU ogni volta che lo apro*/
function animazione_menu_open(){

    jQuery('#menu').animate({width:'toggle'}, {
                        duration: 600,
                        fill: "forwards",
                        easing: "easeOutQuint"
                        });
    jQuery('#menu nav li').each( function() {
        jQuery( this ).addClass('animate__animated animate__rotateInUpLeft animate__delay-1s animate__faster');
    });

}

function animazione_menu_close(){
    jQuery('#menu').animate({width:'toggle'}, {
                        duration: 600,
                        fill: "forwards",
                        easing: "easeInQuint"
                        });
    //jQuery('ul.nav  li').css('opacity','1');
}

// QUANDO CLICCO SU HAMBURGER APRO IL MENU 

var menu_open;
menu_open = document.querySelector('#menu-open');
if(menu_open){
    menu_open.onclick = function() {
        /// non far scorrere la pagina
        ///jQuery('body').css('overflow','hidden');
        animazione_menu_open();
        /*jQuery('#menu').fadeIn(400, function() {
            jQuery('ul.nav .sub-menu li').css('opacity','1');
            jQuery('#menu-sfondo li').fadeOut(200);
            menuShowItems.restart();
            // AVVIO MENU-HOME
             menuHome.restart();
        });
        */
    };

}

// QUANDO CLICCO SU ELEMENTO E CHIUDO IL MENU

var menu_elem;
menu_elem = document.querySelector('#menu ');


if (menu_elem){
    menu_elem.onclick = function() {     
      animazione_menu_close();
   // menuShowItems.restart();
   ///menuShowItems.pause();
   /// jQuery('body').css('overflow','auto');
   /*** 
     jQuery('#menu').fadeOut(600,function(){
         //jQuery('#menu ul.nav>li').css('opacity',0);
        // jQuery('#menu #menu-home li').css('opacity',0);
         
     });
     ***/
    };
}





jQuery(document).ready(function() {

    jQuery('.start_modal_menu').on('click',function() {
     
        jQuery('#search-fabrics-modal').modal('show');

    });


    /* PRELOADING IMMAGINI SFONDO DEL MENU*/
    /*var img1 = new Image();

    img1.onload = function() {};
    img1.src = "/wp-content/themes/sensitive8/dist/images/bg-menu/bg-azienda.jpg";

    var img2 = new Image();

    img2.onload = function() {};
    img2.src = "/wp-content/themes/sensitive8/dist/images/bg-menu/bg-sostenibilita.jpg";


    var img3 = new Image();

    img3.onload = function() {};
    img3.src = "/wp-content/themes/sensitive8/dist/images/bg-menu/bg-tessuti.jpg";

    var img4 = new Image();*/

    
   /*
    img4.onload = function() {};
    img4.src = "/wp-content/themes/sensitive8/dist/images/bg-news.jpg";
   */

    /* FINE PRELOADING IMMAGINI SFONDO DEL MENU*/




   /* ANIMAZIONE MENU DESKTOP */

 /***  jQuery('#menu-sfondo ul li').fadeOut(0);

    jQuery(' #menu .nav-desktop li.menu-sostenibilita').mouseenter(function() {    


        jQuery("#menu-sfondo li:not(.sfondo-sostenibilita)").finish().fadeOut(500);
        jQuery("#menu-sfondo li.sfondo-sostenibilita").finish().fadeIn({
            duration: 1000,
            easing: 'easeOutQuint'

        });

    });

    jQuery(' #menu .nav-desktop li.menu-azienda').mouseenter(function() {

        jQuery("#menu-sfondo li:not(.sfondo-azienda)").finish().fadeOut(500);
        jQuery("#menu-sfondo li.sfondo-azienda").finish().fadeIn({
            duration: 1000,
            easing: 'easeOutQuint'

        });

    });

    jQuery(' #menu .nav-desktop li.menu-tessuti').mouseenter(function() {

        jQuery("#menu-sfondo li:not(.sfondo-tessuti)").finish().fadeOut(500);
        jQuery("#menu-sfondo li.sfondo-tessuti").finish().fadeIn({
            duration: 1000,
            easing: 'easeOutQuint'

        });

    });

    jQuery(' #menu .nav-desktop  li.menu-news').mouseenter(function() {

        jQuery("#menu-sfondo li:not(.sfondo-news)").finish().fadeOut(500);
        jQuery("#menu-sfondo li.sfondo-news").finish().fadeIn({
            duration: 1000,
            easing: 'easeOutQuint'

        });

    });


    jQuery('#menu .nav-desktop ul.nav').mouseleave(function() {
        jQuery('#menu-sfondo li').finish().fadeOut(500);

    });

     /* FINE ANIMAZIONE MENU DESKTOP */


      /* ANIMAZIONE MENU MOBILE */ 

/*
       jQuery('#menu ul.nav>li.menu-item-has-children .ej-menu-separator').click(function(event){
   

        event.preventDefault();
        event.stopPropagation();


        jQuery(this).parent().find('ul.sub-menu li').each(function(){           
            jQuery(this).finish().slideToggle(500);
        }); 
        
       });
*/

      /***  jQuery('#menu ul.nav>li.menu-sostenibilita .ej-menu-separator').click(function(event){
           event.preventDefault();
           event.stopPropagation();

           jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').finish().slideDown(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').addClass('nav-mobile-open');
           });
           jQuery('#menu ul.nav>li.menu-tessuti ul.sub-menu li').finish().slideUp(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').removeClass('nav-mobile-open');
           });
           jQuery('#menu ul.nav>li.menu-news ul.sub-menu li').finish().slideUp(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').removeClass('nav-mobile-open');
           });

        });
        jQuery('#menu ul.nav>li.menu-tessuti .ej-menu-separator').click(function(event){
           event.preventDefault();
           event.stopPropagation();

           jQuery('#menu ul.nav>li.menu-tessuti ul.sub-menu li').finish().slideDown(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').addClass('nav-mobile-open');
           });

           jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').finish().slideUp(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').removeClass('nav-mobile-open');
           });
           jQuery('#menu ul.nav>li.menu-news ul.sub-menu li').finish().slideUp(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').removeClass('nav-mobile-open');
           });

        });
        jQuery('#menu ul.nav>li.menu-news .ej-menu-separator').click(function(event){
           event.preventDefault();
           event.stopPropagation();

           jQuery('#menu ul.nav>li.menu-news ul.sub-menu li').finish().slideDown(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').addClass('nav-mobile-open');
           });

           jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').finish().slideUp(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').removeClass('nav-mobile-open');
           });
           jQuery('#menu ul.nav>li.menu-tessuti ul.sub-menu li').finish().slideUp(500,function(){
            jQuery('#menu ul.nav>li.menu-sostenibilita ul.sub-menu li').removeClass('nav-mobile-open');
           });


        });

            ***/

       



      /* FINE ANIMAZIONE MENU MOBILE */

});

/* MENU - animazione all'hover della voce di  menu */


jQuery(document).ready(function() {


   
  /***
    jQuery(' #menu .nav-desktop ul.nav>li.menu-item-has-children').hover(
        function(){            
            y = 0;

            jQuery(this).find('li').each(function(){
                y = y+1;
                jQuery(this).finish().slideDown(500);
            });
        },
        function(){
            i = 0;
            jQuery(this).find('li').slideUp(500);
        });
        *///
        
});





/* FINE MENU */






function refreshSizeClassToBody(){

    if(jQuery(window).width() < 576 ){
        jQuery('body').addClass('ej-size-mobile');
        jQuery('body').removeClass('ej-size-sm ej-size-md ej-size-lg ej-size-xl');
    }else if(jQuery(window).width() < 768){
         jQuery('body').addClass('ej-size-sm');
         jQuery('body').removeClass('ej-size-mobile  ej-size-md ej-size-lg ej-size-xl');
    }else if(jQuery(window).width() < 992){
         jQuery('body').addClass('ej-size-md');
         jQuery('body').removeClass('ej-size-mobile ej-size-sm  ej-size-lg ej-size-xl');
    }else if(jQuery(window).width() < 1200){
         jQuery('body').addClass('ej-size-lg');
         jQuery('body').removeClass('ej-size-mobile ej-size-sm ej-size-md  ej-size-xl');
    }else{
         jQuery('body').addClass('ej-size-xl');
         jQuery('body').removeClass('ej-size-mobile ej-size-sm ej-size-md ej-size-lg ');
    }
}








jQuery(document).ready(function() {

    /* 
    FOCUSPOINT
    Libreria per posizonare le immagini centrate nel container.
    */

   


    jQuery('#hamburger').hover(function() {
        jQuery(this).toggleClass('open');
    });


    refreshSizeClassToBody();

    jQuery( window ).resize(function() {
           refreshSizeClassToBody();
    });





    
});


